export const SET_USERINFO = 'SET_USERINFO';
export const SET_USERINFOPART = 'SET_USERINFOPART';
export const UPDATA_TABLEDATASING = 'UPDATA_TABLEDATASING';
export const UPDATA_TABLEDATAAIDIT = 'UPDATA_TABLEDATAAIDIT';
export const UPDATA_TABLEDATAREFUSE = 'UPDATA_TABLEDATAREFUSE';
export const UPDATA_TABLEHEADERLIST = 'UPDATA_TABLEHEADERLIST';